function LandingPage() {
  return <p>landing git page</p>;
}

export default LandingPage;
